import { outreach } from '@round/api';
import { ComboboxItem } from '@round/creatorbase-ui';
import { OUTREACH_STATUS_LABELS } from '../OutreachStatusBadge/OutreachStatusBadge';

/** The filters live in the url, so every value is held as the search param string it is written as. */
export type OutreachRequestsFilterValues = {
    /** Comma separated `OutreachStatus` values. */
    status?: string;
    search?: string;
    /** `creatorbase.User` id. */
    createdBy?: string;
};

export type StatusFilterItem = ComboboxItem<outreach.OutreachStatus>;

// Every status is filterable, cancelled included: cancelled requests are listed by default, and
// narrowing them away is what this filter is for.
export const STATUS_FILTER_OPTIONS: StatusFilterItem[] = (
    Object.keys(OUTREACH_STATUS_LABELS) as outreach.OutreachStatus[]
).map((status) => ({ value: status, label: OUTREACH_STATUS_LABELS[status] }));

// An empty list means something different once the user has narrowed it, so the page is told whether
// anything is filtering it rather than inspecting the values itself.
export const getHasActiveFilters = (filters: OutreachRequestsFilterValues): boolean =>
    Boolean(filters.status || filters.search?.trim() || filters.createdBy);

/** Written out rather than derived, so a filter added later has to be accounted for to be clearable. */
export const CLEARED_FILTERS: Record<keyof OutreachRequestsFilterValues, undefined> = {
    status: undefined,
    search: undefined,
    createdBy: undefined,
};

export const getSelectedStatuses = (status: string | undefined): StatusFilterItem[] => {
    const selected = status?.split(',') ?? [];
    return STATUS_FILTER_OPTIONS.filter((option) => selected.includes(option.value));
};
